<ion-modal #modal class="ds-dialog-modal" (didDismiss)="onDidDismiss()">
  <ng-template>
    <div class="ds-dialog-card">

      <button type="button" class="ds-dialog-close" (click)="dismiss()" aria-label="Sluiten">
        <ion-icon name="close-outline"></ion-icon>
      </button>

      <div class="ds-dialog-head">
        <span class="ds-dialog-title">{{ title }}</span>
        <span class="ds-dialog-subtitle" *ngIf="message">{{ message }}</span>
      </div>

      <div class="ds-dialog-body dlg-confirm-actions">
        <ion-button
          *ngFor="let action of actions"
          expand="block"
          class="dlg-confirm-btn"
          [class.dlg-confirm-btn--cancel]="action.role === 'cancel'"
          [fill]="action.role === 'cancel' ? 'clear' : 'solid'"
          [color]="action.danger ? 'danger' : (action.role === 'cancel' ? 'medium' : 'primary')"
          (click)="choose(action.id)">
          {{ action.text }}
        </ion-button>
      </div>

    </div>
  </ng-template>
</ion-modal>
